export default __webpack_public_path__ + "static/media/yabe_image1.55ed155e.png";